import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue"
import AccountType from '@/types/account';


export default /*@__PURE__*/_defineComponent({
  __name: 'DisplayFullnameFromUpdatedBy',
  props: {
    updatedBy: {}
  },
  setup(__props: any) {

const props = __props

const fullName = computed(() => {
  let fullName = ''
  if (props.updatedBy) {
    fullName =  props.updatedBy.full_name
  }
  return fullName
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(fullName.value), 1))
}
}

})